var _stop, _stop2, _stop3, _stop4, _stop5, _stop6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgSummaryNotesIcon(props) {
  const _id3 = useUniqueInlineId();
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.42 0c1.624 0 2.94 1.24 2.94 2.77v16.182c0 1.4-.562 2.747-1.574 3.772l-4.984 5.048c-1.112 1.126-2.672 1.766-4.306 1.766H2.94c-1.624 0-2.94-1.24-2.94-2.769v-24C0 1.24 1.316 0 2.94 0zm0 1.846H2.94c-.541 0-.98.413-.98.923v24c0 .51.439.923.98.923h17.556c.095 0 .189-.003.282-.01h-.286V21.22c0-1.475 1.224-2.68 2.768-2.765l.172-.004 5.967-.001.001-15.68c0-.474-.378-.864-.866-.918l-.114-.006zm.71 18.451h-5.698c-.502 0-.917.356-.973.815l-.007.108v5.98a3.89 3.89 0 00.915-.686l4.984-5.047a3.69 3.69 0 00.78-1.17z",
    transform: "translate(16.66 16.615)",
    fill: "url(#".concat(_id, ")"),
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.78 7.385h22.54c1.566 0 2.846 1.153 2.935 2.606l.005.163v3.723H34.3v-3.723c0-.473-.378-.864-.866-.917l-.114-.006H10.78c-.503 0-.917.356-.973.815l-.007.108v21.681c0 .474.379.864.866.917l.115.006h4.899v1.847h-4.9c-1.565 0-2.845-1.153-2.934-2.607l-.005-.163-.001-21.681c0-1.475 1.224-2.68 2.767-2.765l.173-.004z",
    fill: "url(#".concat(_id2, ")"),
    fillRule: "nonzero",
    transform: "translate(0 1.846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.94 0h22.54c1.566 0 2.846 1.153 2.935 2.607l.005.162v3.723h-1.96V2.77c0-.473-.378-.863-.866-.917l-.114-.006H2.94c-.503 0-.917.357-.973.816l-.007.107v21.682c0 .473.379.863.866.917l.115.006H6.86v1.846H2.94c-1.565 0-2.845-1.153-2.934-2.606L0 24.45V2.769C0 1.295 1.224.09 2.767.005L2.94 0z",
    fill: "url(#".concat(_id3, ")"),
    transform: "translate(0 1.846)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: ".377%",
    x2: "50%",
    y2: "100%",
    id: _id
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17C868",
    offset: 0
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62BD00",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "8.715%",
    y1: "81.85%",
    x2: "80.832%",
    y2: "4.133%",
    id: _id2
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9",
    offset: "0%"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1253FA",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "73.162%",
    y1: "11.072%",
    x2: "22.6%",
    y2: "84.071%",
    id: _id3
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1",
    offset: "0%"
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C27",
    offset: "99.918%"
  })))));
}
export default SvgSummaryNotesIcon;